import script from "./CTASection.vue?vue&type=script&setup=true&lang=js"
export * from "./CTASection.vue?vue&type=script&setup=true&lang=js"

import "./CTASection.vue?vue&type=style&index=0&id=1b014c04&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b014c04"]])

export default __exports__